// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import updateSearchFields from "@insite/client-framework/Store/Pages/Addresses/Handlers/UpdateSearchFields";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Search from "@insite/mobius/Icons/Search";
import TextField, { TextFieldProps } from "@insite/mobius/TextField";
import * as React from "react";
import { connect, ResolveThunks } from "react-redux";

export interface AddressBookSearchBoxStyles {
    searchText?: TextFieldProps;
}

export const searchBoxStyles: AddressBookSearchBoxStyles = {
    searchText: { iconProps: { src: Search } },
};

const styles = searchBoxStyles;

interface OwnProps extends WidgetProps {}

const mapDispatchToProps = {
    updateSearchFields,
};

type Props = OwnProps & ResolveThunks<typeof mapDispatchToProps>;

// XNG-Changes
interface State {
    searchText?: string;
}
class AddressBookSearchBox extends React.Component<Props, State> {
    searchTimeoutId: NodeJS.Timeout | undefined;
    readonly searchMinimumCharacterLength = 3;
    // XNG-Changes
    constructor(props: Props) {
        super(props);
        this.state = {
            searchText: "",
        };
    }
    searchTextChangeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
        clearTimeout(this.searchTimeoutId);

        const searchText = event.currentTarget.value;
        // XNG-Changes
        this.setState({ searchText });
        if (searchText.length > 0 && searchText.length < this.searchMinimumCharacterLength) {
            return;
        }
        this.searchTimeoutId = setTimeout(() => {
            this.props.updateSearchFields({
                filter: searchText,
                page: 1,
            });
        }, 250);
    };

    componentWillUnmount() {
        clearTimeout(this.searchTimeoutId);
    }

    render() {
        return (
            <TextField
                placeholder={translate("Search Ship To")}
                {...styles.searchText}
                onChange={this.searchTextChangeHandler}
                // XNG-Changes
                value={this.state.searchText}
                {...{ showClear: true }}
            />
        );
    }
}

const widgetModule: WidgetModule = {
    component: connect(null, mapDispatchToProps)(AddressBookSearchBox),
    definition: {
        group: "Addresses",
        allowedContexts: ["AddressesPage"],
    },
};

export default widgetModule;
